module.exports = __webpack_public_path__ + "static/media/zoom.bd04f997.svg";